import React, { useState } from 'react';
import Search from '../../containers/Search/Search';
import './Header.scss';

function Header(props) {
  const { title, navLink, enableSearch } = props;
  const [showSearch, showSearchOption] = useState(false);

  function search(flag) {
    showSearchOption(flag);
    window.hideMenu();
  }

  function goBack() {
    const { history } = props;
    history.goBack();
  }

  return (
    <div
      className={`account header display-flex align-items-center${
        navLink ? '' : ' justify-content-center'
      }`}
    >
      {navLink && <span className="back-link" onClick={goBack}></span>}
      <h1 className={`title fsp14 fw400 lh-16 ${enableSearch ? 'flex-1' : ''}`}>{title}</h1>
      {enableSearch && (
        <div
          className="display-flex align-items-center"
          style={{ maxHeight: '30px' }}
          onClick={() => search(true)}
        >
          <span className="mr-l4 mr-r4 icon icon-search"></span>
        </div>
      )}
      {enableSearch && <Search showSearch={search} showSearchModal={showSearch} />}
    </div>
  );
}

export default Header;
